<mat-form-field [formGroup]="form.formGroup">
  <mat-label>Size</mat-label>
  <mat-select [formControlName]="form.formControlNames.size">
    <mat-option *ngFor="let type of size | keyvalue"
    [value]="type.value">{{ type.value }}</mat-option>
  </mat-select>
</mat-form-field>
